var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0241 4.04608C12.6023 4.04608 9.00876 7.63962 9.00876 12.0614V15.9221C9.00876 16.737 8.66143 17.9794 8.2473 18.6741L6.71103 21.2256C5.76255 22.802 6.41713 24.552 8.15379 25.1398C13.9115 27.0635 20.1234 27.0635 25.881 25.1398C27.4975 24.6054 28.2055 22.6951 27.3238 21.2256L25.7875 18.6741C25.3868 17.9794 25.0394 16.737 25.0394 15.9221V12.0614C25.0394 7.65298 21.4325 4.04608 17.0241 4.04608Z",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4965 4.43334C19.0824 4.31311 18.6549 4.2196 18.214 4.16617C16.9316 4.00586 15.7026 4.09937 14.5537 4.43334C14.9411 3.44478 15.903 2.75012 17.0251 2.75012C18.1473 2.75012 19.1091 3.44478 19.4965 4.43334Z",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0314 25.6207C21.0314 27.8249 19.2279 29.6284 17.0237 29.6284C15.9283 29.6284 14.913 29.1742 14.1916 28.4528C13.4703 27.7314 13.0161 26.7161 13.0161 25.6207",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.f33dee6b.svg";
export { ForwardRef as ReactComponent };